import ServiceForm from '../../common/ServiceForm';
import React from 'react';

const ProcedureForm = (props) => (
  <ServiceForm
    {...{
      ...props,
      category: 'Procedures',
      prefixName: 'Procedure',
      requirePE: true,
      requirePlatoTestCode: true,
    }}
  />
);

export default ProcedureForm;
